import {useEffect} from "react";

interface ITurnstileProps {
  callback: (status: string) => any,
  siteKey: string,
}

declare global {
  interface Window {
    turnstileSuccessCallback: (d: any) => void,
    turnstileExpiredCallback: (d: any) => void,
    turnstileErrorCallback: (d: any) => void,
  }
}

function Turnstile({siteKey, callback}: ITurnstileProps) {

  const turnstileSuccessCallback = (d: any) => {
    console.log("turnstile success")
    callback(d);
  }

  const turnstileExpiredCallback = (d: any) => {
    console.log("turnstile expired", d)
    callback("");
  }

  const turnstileErrorCallback = (d: any) => {
    console.log("turnstile error", d)
    callback("");
  }

  useEffect(() => {
    window.turnstileSuccessCallback = turnstileSuccessCallback;
    window.turnstileExpiredCallback = turnstileExpiredCallback;
    window.turnstileErrorCallback = turnstileErrorCallback;

    let scriptUrl = "https://challenges.cloudflare.com/turnstile/v0/api.js";
    let scriptTag = document.createElement("script");
    scriptTag.async = true;
    scriptTag.defer = true;
    scriptTag.src = scriptUrl;
    scriptTag.type = "text/javascript";
    document.body.appendChild(scriptTag);

  })

  return <>
    <div
      className={"cf-turnstile"}
      data-sitekey={siteKey}
      data-theme={"dark"}
      data-callback={"turnstileSuccessCallback"}
      data-expired-callback={"turnstileExpiredCallback"}
      data-error-callback={"turnstileErrorCallback"}
    ></div>
  </>
}

export default Turnstile;
